import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { VehiculeStatus } from 'src/app/shared/enums/vehicule-status-enum';
import { User } from 'src/app/shared/models/security/user';
import { Vehicle } from 'src/app/shared/models/vehicle';

@Component({
	selector: 'app-vehicule-modal-ajout',
	templateUrl: './vehicule-modal-ajout.component.html',
	styleUrls: ['./vehicule-modal-ajout.component.scss']
})
export class VehiculeModalAjoutComponent implements OnInit {
	MAX_NAME_CHAR = 50;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");
	// NUMBER_PATTERN = new RegExp('^[0-9]+$');

	user: User;

	formAjout: FormGroup = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		model: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		rented: new FormControl(''),
		gps: new FormControl(''),
		status: new FormControl(''),
		travelledDistance: new FormControl('', [
			Validators.required
			// Validators.pattern(this.NUMBER_PATTERN)
		]),
		mileageCost: new FormControl('', [
			Validators.required
			// Validators.pattern(this.NUMBER_PATTERN)
		])
	});

	vehiculeStatus = VehiculeStatus;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(public bsModalRef: BsModalRef, private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		this.formAjout.setValue({
			name: '',
			model: '',
			rented: false,
			gps: false,
			status: '',
			travelledDistance: 0,
			mileageCost: 0
		});
	}

	onSubmit() {
		if (this.formAjout.valid) {
			this.isValidateButtonClicked = true;
			let vehicule = new Vehicle();
			vehicule.name = this.name.value;
			vehicule.model = this.model.value;
			vehicule.rented = this.formAjout.get('rented').value;
			vehicule.gps = this.formAjout.get('gps').value;
			vehicule.status = this.formAjout.get('status').value;
			vehicule.travelledDistance = this.travelledDistance.value;
			vehicule.mileageCost = this.mileageCost.value;
			this.facade.vehiculeService.addVehicule(vehicule).subscribe({
				next: (succ) => {
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.isValidateButtonClicked = false;
					this.facade.toastService.createWarningToast(
						"Le véhicule n'a pas pu être ajouté"
					);
				}
			});
		} else {
			this.isValidateButtonClicked = false;
		}
	}

	get name() {
		return this.formAjout.get('name');
	}
	get model() {
		return this.formAjout.get('model');
	}
	get travelledDistance() {
		return this.formAjout.get('travelledDistance');
	}
	get mileageCost() {
		return this.formAjout.get('mileageCost');
	}
}
